export default "__VITE_ASSET__96bac995__"